import axios from 'axios';
import { rootUrl } from 'helpers/baseUrl';
import { getLoggedInUser } from '../helpers/authUtils';

  import store from '../store';
const api = axios.create({
  baseURL: rootUrl,
});
api.interceptors.request.use(function(config){
  // debugger
const state = typeof store !== 'undefined'? store.getState():{auth:{}};

const user = state.auth
const token = user.authUser === null ? '' : user.authUser.token;
  config.headers.Authorization = `Bearer ${token}`
  return config
})
export default api;
